import React from "react";

export default function Footer({ scrollToSeparation, scrollToAboutUs }) {
  return (
    <React.Fragment>
      <footer className="bg-gray-800">
        <div className="grid grid-cols-3 mx-0 md:mx-10 xl:mx-40 pt-2 py-8">
          <div className="col-span-12 md:col-span-3 flex flex-col items-start pl-10">
            <ul className="text-gray-400 my-4">
              <li className="mb-4 text-sm">
                MKI Legal, the law firm Resolvy partners with, has its Liability
                Limited by a Scheme Approved Under Professional Standards
                Legislation.
              </li>
              <li className="mb-4 text-sm">
                The information on this site is not, nor is intended to be,
                legal advice. You should consult a lawyer for individual advice
                regarding your own situation.
              </li>
              <li className="mb-4 text-sm">
                Resolvy is a registered trade mark.
              </li>
            </ul>
          </div>
        </div>
      </footer>
      <footer className="w-full bg-gray-900">
        <p className="text-sm md:text-md text-white pb-4 text-center pt-2">
          <a href="https://www.resolvy.com.au/terms">Terms of Service</a>
          {" | "}

          <a href="https://www.resolvy.com.au/privacy">Privacy Policy</a>

          <p className="my-2"> Copyright Resolvy 2021</p>
        </p>
      </footer>
    </React.Fragment>
  );
}
